'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SaveIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SaveIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Floppy-Disk-2--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Floppy Disk 2 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M23.5 1.5a1 1 0 0 0 -1 -1H3.914a1 1 0 0 0 -0.707 0.293L0.793 3.207a1 1 0 0 0 -0.293 0.707V22.5a1 1 0 0 0 1 1h21a1 1 0 0 0 1 -1Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M19.5 6.5a1 1 0 0 1 -1 1h-13a1 1 0 0 1 -1 -1v-6h15Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M4.5 23.5h15v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M9 13.5a3 3 0 1 0 6 0 3 3 0 1 0 -6 0Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

SaveIcon.propTypes = {
  sx: PropTypes.object
}
